<template>
  <div>
    <v-layout row>
      <h2 class="besetblue--text ml-2 mt-2"> besea </h2>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm8 offset-sm2 lg6 offset-lg3 xl4 offset-xl4>
        <v-card>
          <v-img
          class="white--text"
          height="200px"
          :src="require('@/app/assets/images/plant02.jpg')"
          >
           <v-container fill-height fluid>
             <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span class="title info--text"> licence warning </span>
               </v-flex>
             </v-layout>
           </v-container>
         </v-img>
         <v-layout row>
         <v-spacer/>
           <div class="caption mr-2"> Diavik Mine, Copyright © 2018 Rio Tinto. </div>
         </v-layout>
         <v-card-title primary-title>
           <div>
             <h3 class="headline mb-0 error--text">
               <v-icon right large class="error--text"> warning </v-icon>
               Licence Limit
             </h3>
             <blockquote class="blockquote">
               Please check license options with your Administrator - maximum number of companies or facility or asset access requests exceeded.
             </blockquote>
           </div>
           <!-- <v-layout row>
             <v-flex xs4 offset-xs2>
               <div v-if="1 <= getUser.access.app.comp.length">
                 <v-icon left color="orange">warning</v-icon> No Data
               </div>
               <div v-else>
                 ddd
               </div>
             </v-flex>
           </v-layout> -->
        </v-card-title>
        <v-layout row>
          <v-btn flat color="besetblue" :to="'/welcomeview'">
            <v-icon left> home </v-icon>
            home
           </v-btn>
          <v-spacer/>
          <v-btn flat color="warning" :to="'/userstats'">
            <v-icon left> account_circle </v-icon>
            user
           </v-btn>
         </v-layout>
       </v-card>
      </v-flex>
    </v-layout>
    </v-container>
    <AppNavigationBottom/>
  </div>
</template>

<script>
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";

export default {
  components: {
    AppNavigationBottom
  },
  data: () => ({})
};
</script>
